import { useMemo, useState } from 'react';

/** Plays once per row-key set. Sort order and selection do not replay it. */
export function useDataTableReceive(loading: boolean | undefined, rowKeys: readonly string[]) {
  const receiveKey = useMemo(() => [...rowKeys].sort().join('\u0001'), [rowKeys]);
  const [trackedKey, setTrackedKey] = useState<string | null>(null);
  const [receiveStamp, setReceiveStamp] = useState<string | null>(null);

  if (!loading && trackedKey !== receiveKey) {
    setTrackedKey(receiveKey);
    setReceiveStamp(receiveKey || null);
  }

  return {
    animateReceive: !loading && receiveKey.length > 0 && receiveStamp === receiveKey,
  };
}
